(function(){
  var mobileMenu = document.querySelector('[data-yte-mobile-menu]');
  document.querySelectorAll('[data-yte-menu-toggle]').forEach(function(btn){
    btn.addEventListener('click',function(){ mobileMenu?.classList.toggle('is-open'); });
  });

  var header = document.querySelector('[data-yte-header]');
  if(header){
    var collapseAt = 90;
    var ticking = false;
    var isCollapsed = header.classList.contains('is-scrolled');
    var logoMark = header.querySelector('.yte-header-mark');
    var collapseTimer;

    function animateLogoFlip(before){
      if(!logoMark || !before || !logoMark.animate) return;
      var after = logoMark.getBoundingClientRect();
      var dx = before.left - after.left;
      var dy = before.top - after.top;
      if(Math.abs(dx) < 2 && Math.abs(dy) < 2) return;
      logoMark.animate([
        { transform:'translate3d('+dx+'px,'+dy+'px,0)', opacity:.76 },
        { transform:'translate3d(0,0,0)', opacity:1 }
      ], {
        duration:120,
        easing:'cubic-bezier(.16,1,.22,1)',
        fill:'both'
      });
    }

    function setCollapsed(next){
      if(next === isCollapsed) return;
      var before = logoMark ? logoMark.getBoundingClientRect() : null;
      window.clearTimeout(collapseTimer);
      header.classList.add('is-collapsing');
      header.classList.toggle('is-scrolled', next);
      isCollapsed = next;
      animateLogoFlip(before);
      collapseTimer = window.setTimeout(function(){
        header.classList.remove('is-collapsing');
      }, 140);
    }

    function updateHeader(){
      setCollapsed(window.scrollY > collapseAt);
      ticking = false;
    }

    updateHeader();
    window.addEventListener('scroll', function(){
      if(!ticking){
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive:true });
  }

  document.querySelectorAll('[data-yte-slider]').forEach(function(slider){
    var slides=[].slice.call(slider.querySelectorAll('[data-yte-slide]')); var i=0; var count=slider.querySelector('[data-yte-count]');
    function show(n){ if(!slides.length)return; slides[i].classList.remove('is-active'); i=(n+slides.length)%slides.length; slides[i].classList.add('is-active'); if(count) count.textContent=String(i+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0'); }
    slider.querySelector('[data-yte-next]')?.addEventListener('click',function(){show(i+1)}); slider.querySelector('[data-yte-prev]')?.addEventListener('click',function(){show(i-1)}); show(0);
  });
})();